"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = exports.StyledCheckbox = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
exports.StyledCheckbox = styled_components_1.default.div `
	display: flex;
	align-items: flex-end;
	position: relative;

	label {
		position: relative;
		cursor: pointer;
		padding: 0;
		color: ${({ theme }) => theme.gray3};
	}

	.checkbox-icon {
		font-size: 22px;
		padding-right: 10px;
		padding-left: 10px;
		color: ${({ theme }) => theme.denimBlue};
	}

	input {
		position: absolute;
		opacity: 0;
		top: 0;
		cursor: pointer;

		&:focus + label {
			outline-offset: 1px;
			outline: -webkit-focus-ring-color auto 1px;
		}
	}

	input:disabled + label .checkbox-icon {
		color: ${({ theme }) => theme.gray};
		cursor: auto;
	}
`;
const defaultProps = {
    disabled: false,
    checked: false,
    onChange: () => { }
};
const Checkbox = ({ name, id, disabled, checked, onChange, children }) => {
    return (react_1.default.createElement(exports.StyledCheckbox, { role: "group" },
        react_1.default.createElement("input", { type: "checkbox", name: name, id: id, checked: checked, disabled: disabled, onChange: onChange, "aria-checked": checked, tabIndex: 0 }),
        react_1.default.createElement("label", { htmlFor: name },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: checked ? pro_solid_svg_icons_1.faCheckSquare : pro_regular_svg_icons_1.faSquare, className: "checkbox-icon" }),
            children)));
};
exports.Checkbox = Checkbox;
exports.Checkbox.defaultProps = defaultProps;
